(function () {
  if (window.ProductRows) return;

  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  var observers = new WeakMap();

  function initPickers(root) {
    root.querySelectorAll('[data-picker]').forEach(function (picker) {
      if (picker.dataset.bound === 'true') return;
      picker.dataset.bound = 'true';

      var card = picker.closest('.pr-card');
      var json = picker.querySelector('[data-variants]');
      var variants = [];

      try {
        variants = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }

      var groups = Array.prototype.slice.call(picker.querySelectorAll('.pr-card__opt'));
      var idInput = card.querySelector('[data-variant-id]');
      var addBtn = card.querySelector('[data-add]');
      var link = card.querySelector('[data-product-link]');
      var linkBase = link ? link.getAttribute('href').split('?')[0] : '';
      var priceEl = card.querySelector('[data-price]');
      var wasEl = card.querySelector('[data-price-was]');
      var fromEl = card.querySelector('[data-price-from]');
      var mainImg = card.querySelector('.pr-card__img:not(.pr-card__img--hover)');
      // Only touch the text span: base.js needs the button's icon elements intact
      var addLabel = addBtn ? addBtn.querySelector('[data-add-text]') || addBtn : null;
      var addText = addLabel ? addLabel.textContent.trim() : '';
      var soldOutText = addBtn ? addBtn.dataset.soldOut || 'Sold out' : 'Sold out';

      // Swatch images can't be set via inline style in Liquid, so apply them here
      picker.querySelectorAll('[data-swatch]').forEach(function (chip) {
        chip.style.setProperty('--chip-image', 'url("' + chip.dataset.swatch + '")');
      });

      function selection() {
        return groups.map(function (group) {
          var chosen = group.querySelector('.is-selected');
          return chosen ? chosen.dataset.value : null;
        });
      }

      // Prefer an in-stock variant when several match the visible options
      function match(values) {
        var matches = variants.filter(function (v) {
          return values.every(function (val, i) {
            return val === null || v.options[i] === val;
          });
        });
        return matches.find(function (v) { return v.available; }) || matches[0];
      }

      // Price, image and link only change once the shopper picks something,
      // so the card keeps its "From" price on load
      function refresh(userChanged) {
        var values = selection();
        var variant = match(values);

        // Grey out combinations that don't exist or are sold out
        groups.forEach(function (group, index) {
          group.querySelectorAll('.pr-card__chip').forEach(function (chip) {
            var test = values.slice();
            test[index] = chip.dataset.value;
            var found = match(test);
            var unavailable = !found || !found.available;
            chip.classList.toggle('is-unavailable', unavailable);
            chip.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
            chip.setAttribute('aria-pressed', chip.classList.contains('is-selected') ? 'true' : 'false');
          });
        });

        if (idInput) idInput.value = variant ? variant.id : '';

        if (addBtn) {
          var ok = variant && variant.available;
          addBtn.disabled = !ok;
          addLabel.textContent = ok ? addText : soldOutText;
          if (userChanged) addBtn.classList.remove('added', 'successful');
        }

        if (!userChanged || !variant) return;

        if (priceEl && variant.price) {
          priceEl.textContent = variant.price;
          priceEl.classList.toggle('pr-card__price-current--sale', !!variant.compare_at);
        }

        if (wasEl) {
          wasEl.textContent = variant.compare_at || '';
          wasEl.hidden = !variant.compare_at;
        }

        if (fromEl) fromEl.hidden = true;

        if (link) link.href = linkBase + '?variant=' + variant.id;

        if (mainImg && variant.image) {
          mainImg.srcset = '';
          mainImg.src = variant.image;
        }
      }

      picker.addEventListener('click', function (event) {
        var chip = event.target.closest('.pr-card__chip');
        if (!chip) return;

        var group = chip.closest('.pr-card__opt');
        group.querySelectorAll('.pr-card__chip').forEach(function (other) {
          other.classList.toggle('is-selected', other === chip);
        });

        refresh(true);
      });

      refresh(false);
    });
  }

  // Hover images ship with data-src/data-srcset so they only download when needed
  function initHoverImages(root) {
    if (!canHover) return;

    root.querySelectorAll('.pr-card__media').forEach(function (media) {
      var img = media.querySelector('.pr-card__img--hover[data-src]');
      if (!img || media.dataset.hoverBound === 'true') return;
      media.dataset.hoverBound = 'true';

      media.addEventListener('pointerenter', function () {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      }, { once: true });
    });
  }

  function initSliders(root) {
    root.querySelectorAll('.pr-row__slider').forEach(function (slider) {
      var track = slider.querySelector('[data-track]');
      if (!track || track.dataset.bound === 'true') return;
      track.dataset.bound = 'true';

      var prev = slider.querySelector('[data-arrow="prev"]');
      var next = slider.querySelector('[data-arrow="next"]');
      var progress = slider.querySelector('[data-progress]');

      function step() {
        var first = track.querySelector('.pr-row__item');
        var card = first ? first.getBoundingClientRect().width : track.clientWidth / 2;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var perView = Math.max(1, Math.round(track.clientWidth / (card + gap)));
        return (card + gap) * perView;
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.hidden = track.scrollLeft <= 2;
        if (next) next.hidden = max <= 0 || track.scrollLeft >= max;

        if (progress) {
          var ratio = Math.min(1, track.clientWidth / track.scrollWidth);
          var pos = max > 0 ? Math.min(1, track.scrollLeft / max) : 0;
          progress.style.width = (ratio * 100) + '%';
          progress.style.transform = 'translateX(' + ((1 / ratio - 1) * 100 * pos) + '%)';
          progress.parentElement.style.visibility = ratio >= 1 ? 'hidden' : '';
        }
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      track.addEventListener('scroll', sync, { passive: true });

      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(sync);
        observer.observe(track);
        observers.set(track, observer);
      }

      sync();
    });
  }

  function init(root) {
    if (!root) return;
    initPickers(root);
    initHoverImages(root);
    initSliders(root);
  }

  function destroy(root) {
    if (!root) return;
    root.querySelectorAll('[data-track]').forEach(function (track) {
      var observer = observers.get(track);
      if (observer) observer.disconnect();
      observers.delete(track);
    });
  }

  window.ProductRows = { init: init, destroy: destroy };

  function initAll() {
    document.querySelectorAll('.product-rows').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('.product-rows'));
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target.querySelector('.product-rows'));
  });
})();
